import React from 'react';

interface XIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export default function XIcon({ width = 22, height = 22, className = '' }: XIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      className={className}
    >
      <path
        d="M11 21.4985C16.799 21.4985 21.5 16.7978 21.5 10.9993C21.5 5.20068 16.799 0.5 11 0.5C5.20101 0.5 0.5 5.20068 0.5 10.9993C0.5 16.7978 5.20101 21.4985 11 21.4985Z"
        fill="#4B5563"
        stroke="white"
        strokeWidth="0.0218138"
        strokeMiterlimit="10"
      />
      <path
        d="M4.53944 4.91602L9.55832 11.6261L4.50781 17.0818H5.64457L10.0664 12.3052L13.6389 17.0818H17.5071L12.2057 9.9943L16.9068 4.91602H15.77L11.6979 9.31505L8.4076 4.91602H4.53944ZM6.21109 5.7532H7.98811L15.8352 16.2446H14.0582L6.21109 5.7532Z"
        fill="white"
      />
    </svg>
  );
}
